export * from './money-format.pipe';
export * from './button-text.pipe';
export * from './carousel-config.pipe';
export * from './capitalise.pipe';
export * from './phone.pipe';
export * from './removeHTML.pipe';
export * from './format-duration.pipe';
export * from './add-to-cart-text.pipe';
